import React from 'react'

import { Table } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import RowTemplate from './rowTemplate'

const DocumentosPendientes = ({ filas, dispatch }) => {
  const filasValidas = React.useMemo(() => {
    const filasSoles = filas.filter(x => x.moneda === MonedasConstant.SOLES)
    const filasDolares = filas.filter(x => x.moneda === MonedasConstant.DOLARES)
    const filasEuros = filas.filter(x => x.moneda === MonedasConstant.EUROS)

    return [...filasSoles, { empty: true }, ...filasDolares, { empty: true }, ...filasEuros]
  }, [filas])

  return (
    <Table
      headRows={[
        { label: 'FEC. EMI' },
        { label: 'FEC. VEN' },
        { label: 'TIPO' },
        { label: 'SERIE' },
        { label: 'DOCUMENTO' },
        { label: 'MONEDA' },
        { label: 'SALDO' },
        { label: 'MONTO', width: 100 },
        { label: '', width: 30 }
      ]}
      filas={filasValidas}
      maxRowsShown={5}
      rowTemplate={(row, k) => (
        <React.Fragment key={k}>
          {row.empty ? (
            <Table.Row>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
              <Table.Cell></Table.Cell>
            </Table.Row>
          ) : (
            <RowTemplate row={row} dispatch={dispatch} />
          )}
        </React.Fragment>
      )}
    />
  )
}

export default React.memo(DocumentosPendientes)
